import { Box, useMediaQuery, useTheme } from '@mui/material';
import Chatbot from '../Chatbot/Chatbot';
import { MOBILE_BOTTOM_NAV_OFFSET, MOBILE_CHATBOT_OVERLAY_Z } from '../../config/mobileNavConfig';

/**
 * Frame for the assist shell. Mobile pins to the viewport above the bottom nav
 * without a 100dvh height, which otherwise spills over the tab bar.
 */
export function getMobileChatbotOverlayFrameSx(useSidebarLayout) {
  if (useSidebarLayout) {
    return {
      top: 0,
      right: 0,
      left: 'auto',
      width: { xs: '100vw', md: 500 },
      maxWidth: '100vw',
      height: { xs: '100dvh', md: '100vh' },
      borderLeft: { md: '4px solid #3a3a3a' },
    };
  }

  return {
    top: 0,
    left: 0,
    right: 0,
    bottom: MOBILE_BOTTOM_NAV_OFFSET,
    width: '100%',
    maxWidth: '100vw',
    overflow: 'hidden',
  };
}

/**
 * Mobile-first chatbot shell used by primary nav pages.
 * On viewports below md, reserves space for the fixed bottom navigation bar
 * so the chat composer always sits above it.
 */
const MobileChatbotOverlay = ({ open, setOpen, sidebarOnMd = true }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const useSidebarLayout = sidebarOnMd && isMdUp;

  if (!open) return null;

  return (
    <Box
      data-testid="yovo-mobile-chat-overlay"
      sx={{
        position: 'fixed',
        zIndex: MOBILE_CHATBOT_OVERLAY_Z,
        display: 'flex',
        flexDirection: 'column',
        background: useSidebarLayout ? '#181818' : '#E8E9ED',
        color: '#fff',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        overflow: 'hidden',
        ...getMobileChatbotOverlayFrameSx(useSidebarLayout),
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Chatbot open={open} setOpen={setOpen} flushBottom={!useSidebarLayout} />
      </Box>
    </Box>
  );
};

export default MobileChatbotOverlay;
